<template>
  <div
    v-if="loading"
    :class="skeletonClass"
    class="bg-slate-200 animate-pulse rounded-full border-2 border-white shadow-sm"
  ></div>

  <div v-else class="flex items-center gap-2 bg-white rounded-full">
    <div
      @click="handleClick"
      @mouseover="isHovering = true"
      @mouseleave="isHovering = false"
      :class="containerClass"
    >
      <svg xmlns="http://www.w3.org/2000/svg" :class="svgClass" viewBox="0 0 24 24">
        <path :d="mdiHistory" fill="#2F7F91" />
      </svg>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { mdiHistory } from '@mdi/js'

const props = withDefaults(
  defineProps<{
    isActive?: boolean
    size?: 'normal' | 'small'
    loading?: boolean
  }>(),
  {
    size: 'normal',
    loading: false
  }
)

const emit = defineEmits<{
  (e: 'click'): void
}>()

const isClicked = ref(false)
const isHovering = ref(false)

function handleClick() {
  isClicked.value = !isClicked.value
  emit('click')
}

const skeletonClass = computed(() => {
  return props.size === 'small' ? 'w-9 h-9' : 'w-12 h-12'
})

const containerClass = computed(() => {
  const sizeClasses = props.size === 'small' ? 'w-9 h-9' : 'w-12 h-12'
  const backgroundClass = isHovering.value ? 'bg-[#D5EDF2]' : 'bg-transparent'

  return [
    'flex items-center justify-center rounded-full border-2 border-primary30 transition-all duration-300 cursor-pointer',
    sizeClasses,
    backgroundClass
  ]
})

const svgClass = computed(() => {
  return props.size === 'small' ? 'w-6 h-6' : 'w-8 h-8'
})
</script>
